// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as OauthCallbackRouteImport } from './routes/oauth/callback'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangDocsSplatRouteImport } from './routes/$lang/docs/$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/$lang/',path: '/$lang/',getParentRoute: () => rootRouteImport
          })
const OauthCallbackRoute = OauthCallbackRouteImport.update({
            id: '/oauth/callback',path: '/oauth/callback',getParentRoute: () => rootRouteImport
          })
const LangAboutRoute = LangAboutRouteImport.update({
            id: '/$lang/about',path: '/$lang/about',getParentRoute: () => rootRouteImport
          })
const LangDocsSplatRoute = LangDocsSplatRouteImport.update({
            id: '/$lang/docs/$',path: '/$lang/docs/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangAboutRoute: LangAboutRoute,OauthCallbackRoute: OauthCallbackRoute,LangIndexRoute: LangIndexRoute,LangDocsSplatRoute: LangDocsSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)